<!---->
<template>
    <div>
    </div>
</template>

<script>
export default {
    components: {},
    data() {
        return {}
    },
    computed: {},
    watch: {},
    methods: {},
    created() {
    }
}
</script> 

<style scoped lang='scss'></style>



// WEBPACK FOOTER //
// src/components/aboution.vue